<svg [climbIcon]="icons.arrowLeft"></svg>
<span #buttonLabel class="button-label"><ng-content></ng-content></span>
